export const MODAL_TITLE_ID = "fs-modal-title";

export const MODAL_INITIAL_FOCUS_ATTR = "data-fs-modal-initial-focus";

export const MODAL_ANIMATION_TIME_MS = 250;
export const MODAL_STICKY_DETECTION_HEADER_OFFSET = 25;

export const MODAL_WIDTH_VARIANTS = [
  "small",
  "medium",
  "large",
  "xlarge",
  "custom",
] as const;

export const MODAL_HEADER_VARIANTS = [
  "default",
  "customSlot",
  "condensed",
] as const;

export const MODAL_FOOTER_VARIANTS = ["default", "customSlot"] as const;

export const MODAL_FOOTER_MAX_BUTTON_QTY = 3;

export const MODAL_CLOSE_VARIANTS = ["default", "onColor"] as const;
export const MODAL_HEIGHT_VARIANTS = ["partialScreen", "fullScreen"] as const;
export const MODAL_IMAGE_ASPECT_RATIO_VARIANTS = [
  "fiveToTwo",
  "twoToOne",
] as const;
